import React, { createContext, useContext } from 'react';

const TokenContext = createContext();

export const useTokenRefresh = () => {
    const context = useContext(TokenContext);
    if (!context) {
        throw new Error('useTokenRefresh must be used within a TokenProvider');
    }
    return context;
};

export const TokenProvider = ({ children, refreshFunction, getAccessTokenFunction }) => {
    return (
        <TokenContext.Provider value={{
            refreshToken: refreshFunction,
            getAccessToken: getAccessTokenFunction
        }}>
            {children}
        </TokenContext.Provider>
    );
};